//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class NotificationGroup extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'NotificationGroup';
    // @ts-ignore
    this.prototype.urlRoot = '/1/notificationGroups';
  }
}
NotificationGroup.initClass();

export { NotificationGroup };
